module.exports = __webpack_public_path__ + "img/logo.39679ad2.png";